import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {TranslateService, TranslateModule} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {StreamingLabels, StreamingTypes} from "src/app/enums/StreamingType";
import {StreamingOption} from "src/app/models/Movie";
import {AsyncPipe, NgClass} from "@angular/common";
import {getStreamingServiceLogoPath} from "src/app/utils/streaming-service-logo.util";

@Component({
  selector: "app-display-streaming-option",
  templateUrl: "./display-streaming-option.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass, TranslateModule],
})
export class DisplayStreamingOptionComponent {
  @Input() streamingService!: StreamingOption;
  @Input() userHasAccess = false;
  public streamingTypes = StreamingTypes;

  constructor(private readonly translate: TranslateService) {}

  public getServiceLogoPath(serviceId: string): string {
    return getStreamingServiceLogoPath(serviceId);
  }

  public getStreamingTypeLabel$(key: string): Observable<string> {
    return this.translate.get(
      StreamingLabels[key as keyof typeof StreamingLabels] ?? key
    );
  }
}
